import { ReactNode } from 'react';
import { Helmet } from 'react-helmet';

type MetaDataProps = {
  title?: ReactNode;
  description?: string;
};

const MetaData = ({ title = 'Controlpanel | i3D.net', description = '' }: MetaDataProps) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
  </Helmet>
);

export default MetaData;
